<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Clinic",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Clinic",
            items: [
               {
                  text: "Clinic",
                  href: "/clinics",
               },
               {
                  text: "Edit Clinic",
                  active: true,
               },        
            ],


            clinic: {
               id: null,
               name : "Aster Clinic",
               place: "Kochi",
               phone: "1234567890",
               email: "aster@test.com",
            },

            clinic_location: 'Kochi, Kerala, India',
            clinic_marker: { position: { lat: 9.9312328, lng: 76.26730409999999 } },
            clinic_center: { lat: 9.9312328, lng: 76.26730409999999 },
            clinic_current_place: null,

            clinic_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
         };
      },
      mounted() {
    
      },

      methods: {
         //sets the position of marker when dragged
         clinicHandleMarkerDrag(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         clinicPanToMarker() {
            this.$refs.clinicMapRef.panTo(this.clinic_marker.position);
            this.$refs.clinicMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         clinicHandleMapClick(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         clinicSetPlace(place) {
            this.clinic_current_place = place;
            if(this.clinic_current_place) {
               const marker = {
                  lat: this.clinic_current_place.geometry.location.lat(),
                  lng: this.clinic_current_place.geometry.location.lng(),
               };
               this.clinic_center = marker;
               this.clinic_marker.position = marker;
               this.clinic_location = place.formatted_address;
            }
         },
      }
   }
</script>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'clinics' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form">
                        
                        <div class="row">
                           
                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Place<span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic.place" v-bind:class="{ 'is-invalid': Boolean(errors.place) }"></b-form-input>
                              <div v-for="(val, index) in errors.place" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Phone</label>
                              <b-form-input v-model="clinic.phone" v-bind:class="{ 'is-invalid': Boolean(errors.phone) }"></b-form-input>
                              <div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Email<span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="clinicSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="clinic_location"/>
                              
                              <GmapMap v-if="clinic_location"
                                 :center="clinic_center"
                                 :zoom="18"
                                 map-style-id="clinic-roadmap"
                                 :options="clinic_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="clinicMapRef"
                                 @click="clinicHandleMapClick">
                                    <GmapMarker
                                       :position="clinic_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="clinicHandleMarkerDrag"
                                       @click="clinicPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic_marker.position.lat"></b-form-input>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic_marker.position.lng"></b-form-input>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Update</button>
                              <router-link :to="{ name: 'clinics' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>


                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form">
                        <h4 class="font-size-16 mb-4">Change Password</h4>
                        <div class="row">

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="clinic.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="clinic.password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                              <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Update</button>
                              <router-link :to="{ name: 'clinics' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
